<template>
    <div>
        this is the admin dashboard
    </div>
</template>

<script>
export default {
    name: "AdminDashboard"
}
</script>